import { registerMutation, registerQuery } from 'data-fetching-client';
import { fetchCloneInfoRequest } from 'email-management-lib/EmailClone/apis/clone';
import http from 'hub-http/clients/apiClient';
export const CLONE_EMAIL = registerMutation({
  fieldName: 'cloneEmail',
  args: ['id', 'payload'],
  fetcher: ({
    id,
    payload
  }) => {
    return http.post(`/cosemail/v1/emails/${id}/clone`, {
      data: payload
    });
  }
});
export const FETCH_CLONE_INFO = registerQuery({
  fieldName: 'cloneInfo',
  args: ['emailId', 'checkIfConvertibleToDragAndDrop'],
  fetcher({
    emailId,
    checkIfConvertibleToDragAndDrop
  }) {
    return fetchCloneInfoRequest(emailId, checkIfConvertibleToDragAndDrop);
  }
});
export const FETCH_VARIANT_CLONE_INFO = registerQuery({
  fieldName: 'cloneInfo',
  args: ['variantId', 'checkIfConvertibleToDragAndDrop'],
  fetcher({
    variantId,
    checkIfConvertibleToDragAndDrop
  }) {
    return fetchCloneInfoRequest(variantId, checkIfConvertibleToDragAndDrop);
  }
});